import createLogger from '@cloudflare/util-logger';

var logError = createLogger('user-tracking:error');
var logWarn = createLogger('user-tracking:warn');
var logInfo = createLogger('user-tracking:info');

var _ga = global.ga;
var defaultTrackerName = null;

/*
 Initialize Google Analytics. This must be called before using functions in
 this module which transmit events to GA (ideally in the app's startup routine).
 Allows for the creation of multiple trackers are startup.

 It takes an array of tracker specs as its only argument::
    initGA([
      {
        property: 'dashboard',
        trackingId: 'UA-1234'
        defaultTracker: true
      },
      {
        property: 'onboarding',
        trackingId: 'UA-2345'
      }
    ]);

 The value of 'property' is used as the tracker name and should ideally match
 what's in the GA dashboard.
*/
export var initGA = function initGA(trackerSpecs) {
  if (!_ga) {
    logError('ga function not defined in initGA. Analytics collection is disabled!');
    return;
  }

  trackerSpecs.forEach(function (_ref) {
    var property = _ref.property,
        trackingId = _ref.trackingId,
        defaultTracker = _ref.defaultTracker;

    _ga('create', trackingId, 'auto', property);
    if (defaultTracker) {
      defaultTrackerName = property;
    }
  });
};

export var sendGAEvent = function sendGAEvent(_ref2) {
  var category = _ref2.category,
      action = _ref2.action,
      label = _ref2.label,
      value = _ref2.value,
      _ref2$options = _ref2.options,
      options = _ref2$options === undefined ? {} : _ref2$options;

  if (!_ga) {
    logError('ga uninitialized. Please call "initGA" before sending events');
    return;
  }

  if (!category || !action) {
    logWarn('sendEvent requires category and action!');
  }

  if (typeof value !== 'undefined') {
    if (typeof value !== 'number') {
      logWarn('sendEvent expects value to be a number!');
    }
  }

  var message = 'sendEvent: { category: "' + category + '" } { action: "' + action + '" }';
  if (label) {
    message += ' { label: ' + label + ' }';
  }
  if (value) {
    message += ' { value: ' + value + ' }';
  }
  logInfo(message);

  var defaultSendCmd = defaultTrackerName ? defaultTrackerName + '.send' : 'send';

  var sendCmd = options.property ? options.property + '.send' : defaultSendCmd;

  _ga(sendCmd, {
    hitType: 'event',
    eventCategory: category,
    eventAction: action,
    eventLabel: label,
    eventValue: value
  });
};

export var setGADimension = function setGADimension(dimension, value) {
  if (!_ga) {
    logError('ga function not defined, bailing on setDimension');
    return;
  }

  if (!dimension || !value) {
    logWarn('setDimension requires dimension and value!');
  }

  if (typeof value !== 'undefined') {
    if (typeof value !== 'string') {
      logWarn('setDimension expects value to be a string!');
    }
  }

  var message = 'setDimension: { dimension: "' + dimension + '" } { value: "' + value + '" }';
  logInfo(message);

  // Set the dimension for all trackers
  _ga('set', dimension, value);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/util-user-tracking/es/GoogleAnalytics.js
// module id = 1075
// module chunks = 1